import { AxiosRequestHeaders } from 'axios';

const getCSRFHeader = (): AxiosRequestHeaders => {
  const csrfToken = document?.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

  return csrfToken ? { 'X-CSRF-Token': csrfToken } : {};
};

export function getCsrfToken() {
  return document?.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
}

export default getCSRFHeader;
